@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">New York</h2>

  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!--BEL Radio Group-->
      @if (baseRules["BasicEconomicLossWithMedical_LevelOne_Radio"]?.includes("show")) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[0].formControlName)?.value === null ||
              reactiveForm.get(controls[0].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          @if (controls?.length >= 1) {
            <label class="axis-control-label">
              {{ controls[0].label }}
              <span
                aria-hidden="true"
                class="axis-required-indicator"
                >*</span
              >
            </label>
            <axis-radio-button-wrapper
              formControlName="{{ controls[0].formControlName }}"
              [ngClass]="{
                'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === '',
              }"
            >
              @for (control of controls[0].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[0].formControlName }}"
                ></axis-radio>
              }
            </axis-radio-button-wrapper>
            @if (reactiveForm.get(controls[0].formControlName)?.touched) {
              @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          }
        </div>
      }
      @if (
        baseRules["BEL_Medical_Expense_Text"]?.includes("show") &&
        baseRules["BasicEconomicLossWithMedical_LevelOne_Radio"]?.includes("Yes")
      ) {
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            id="basiceconomiclosswithmedical_levelone_radio-pdffield-new-york"
            >{{ textValues?.BEL_Medical_Expense_Text }}</label
          >
        </div>
      }

      <!-- BEL Description Text -->
      @else if (baseRules["BEL_Medical_Expense_Text"]?.includes("show")) {
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            id="basiceconomiclosswithmedical_levelone_radio-pdffield-new-york"
            >{{ textValues?.BEL_Medical_Expense_Text }}</label
          >
        </div>
      }

      <!--OBEL Selection dropdown group-->
      <div class="axis-grid">
        @if (
          baseRules["Optional_Basic_Economic_Loss_DropDown"]?.includes("show") ||
          baseRules["Optional_Basic_Economic_Loss_DropDown"]?.includes("form")
        ) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[1].formControlName)?.value === null ||
                  reactiveForm.get(controls[1].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[1].formControlName)?.touched &&
                  reactiveForm.get(controls[1].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
              >
                {{ controls[1].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[1].data"
                id="{{ controls[1].formControlName }}"
                formControlName="{{ controls[1].formControlName }}"
                (onSelect)="controls[1].selectedPremium = $any($event).premium"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
              @if (controls[1].selectedPremium) {
                <div [hidden]="!showPremium">Premium per Vehicle: {{ controls[1].selectedPremium }}</div>
              }
            </div>
          </div>
        }
      </div>

      <!-- OBEL Description Text -->
      @if (baseRules["OBEL_Description_Text"]?.includes("show")) {
        <div class="axis-form-group">
          <label class="axis-control-label">{{ textValues?.OBEL_Description_Text }}</label>
        </div>
      }

      <!--Additional PIP Selection dropdown group-->
      <div class="axis-grid">
        @if (baseRules["Additional_PIP_DropDown"]?.includes("form")) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[2].formControlName)?.value === null ||
                  reactiveForm.get(controls[2].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[2].formControlName)?.touched &&
                  reactiveForm.get(controls[2].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[2].formControlName }}"
                >{{ controls[2].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                ></label
              >
              <axis-dropdown
                [dataProvider]="controls[2].data"
                (onSelect)="
                  eventHook('Additional_PIP_DropDown');
                  optionsSelection = {
                    Total_Additional_PIP_Limits: $event.Total_Additional_PIP_Limits || '',
                    Monthly_Work_Loss: $event.Monthly_Work_Loss || '',
                    Other_Expenses_Per_Day: $event.Other_Expenses_Per_Day || '',
                  };
                  controls[2].selectedPremium = $event.premium
                "
                id="{{ controls[2].formControlName }}"
                formControlName="{{ controls[2].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[2].formControlName)?.touched) {
                @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
              @if (controls[2].selectedPremium) {
                <div [hidden]="!showPremium">Premium: {{ controls[2].selectedPremium }}</div>
              }
            </div>
          </div>
        }
      </div>
      <div class="axis-grid">
        @for (
          field of [
            { key: "Total_Additional_PIP_Limits", textKey: "Total_Additional_PIP_Limits_Text" },
            { key: "Monthly_Work_Loss", textKey: "Monthly_Work_Loss_Text" },
            { key: "Other_Expenses_Per_Day", textKey: "Other_Expenses_Per_Day_Text" },
          ];
          track field.key
        ) {
          @if (optionsSelection[field.key]) {
            <div class="axis-col-sm-6 axis-col-md-4">
              <div class="axis-form-group _mt-medium">
                <label class="axis-control-label">
                  {{ textValues?.[field.textKey] }}
                </label>
                <div>{{ optionsSelection[field.key] }}</div>
              </div>
            </div>
          }
        }
      </div>
      @if (baseRules["Additional_Death_Benefit_Checkbox"]?.includes("show")) {
        <div class="axis-grid _mt-large">
          <div class="_ml-medium _mb-medium">
            <axis-checkbox
              [formControlName]="controls[3].formControlName"
              [heading]="controls[3].label"
            ></axis-checkbox>
          </div>
        </div>
      }
    </form>
  }
  <!-- NY Refer -->
  <div class="axis-form-group _mt-medium">
    <p>
      {{ textValues?.["Refer_Text"] }}
    </p>
  </div>
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">New York</h2>
  @if (baseRules?.minLimit === "Yes") {
    <div class="axis-form-group">
      <label
        class="axis-control-label"
        id="basiceconomiclosswithoutmedical_levelone_radio-pdffield-new-york"
        >{{ textValues?.Limits_Text }}</label
      >
    </div>
  }
  <!-- Read Only Medical Expense Radio-->
  @if (baseRules["BasicEconomicLossWithMedical_LevelOne_Radio"]?.includes("Yes")) {
    <div class="axis-grid _mt-large">
      <div class="_ml-medium _mb-medium">
        <label class="axis-control-label">
          {{ controls[0].label }}
        </label>
      </div>
    </div>
  }
  <!-- Read only Optional Basic Economic Loss for New York -->
  <div class="axis-grid">
    @if (baseRules?.Yes_Optional_Basic_Economic_Loss_DropDown) {
      @if (controls?.length > 4) {
        @for (control of controls; track control.formControlName) {
          @if (control.formControlName === "Yes_Optional_Basic_Economic_Loss_DropDown") {
            <!-- Display OBEL label -->
            <div class="axis-col-12">
              <div class="_mt-medium">
                <label class="axis-control-label">
                  {{ control.label }}
                </label>
              </div>
            </div>

            <!-- Display OBEL option details -->
            @if (control.data?.length > 0 && control.data[0]) {
              <div class="axis-col-sm-6 axis-col-md-4">
                <div class="axis-form-group">
                  <div class="axis-info-text">
                    {{ control.data[0]["name"] }}
                  </div>
                </div>
              </div>

              @if (control.data[0]["premium"]) {
                <div
                  class="axis-col-sm-6 axis-col-md-4"
                  [hidden]="!showPremium"
                >
                  <div class="axis-form-group _mt-medium">
                    <label class="axis-control-label"> Premium per Vehicle </label>
                    <div class="axis-info-text">
                      {{ control.data[0]["premium"] }}
                    </div>
                  </div>
                </div>
              }
            }
          }
        }
      }
    }
  </div>
  <!-- Read only Added Benefits Options for New York -->
  <div class="axis-grid">
    @for (
      benefitOption of [
        { rule: baseRules?.Min_Additional_PIP_DropDown, controlIndex: 6 },
        { rule: baseRules?.Max_Additional_PIP_DropDown, controlIndex: 5 },
      ];
      track $index
    ) {
      @if (benefitOption.rule) {
        @if (controls?.[benefitOption.controlIndex]?.label) {
          <div class="axis-col-12">
            <div class="axis-form-group _mt-medium">
              <label class="axis-control-label">
                {{ controls[benefitOption.controlIndex].label }}
              </label>
            </div>
          </div>
        }
        @if (controls?.[benefitOption.controlIndex]?.data?.length > 0 && controls[benefitOption.controlIndex].data[0]) {
          <!-- Display option name -->
          <div class="axis-col-12">
            <div class="axis-form-group _mt-small">
              <div class="axis-info-text axis-font-bold">
                {{ controls[benefitOption.controlIndex].data[0].name }}
              </div>
            </div>
          </div>

          <!-- Display option values -->
          @for (field of ["Total_Additional_PIP_Limits", "Monthly_Work_Loss", "Other_Expenses_Per_Day"]; track field) {
            @if (controls[benefitOption.controlIndex].data[0][field]) {
              <div class="axis-col-sm-6 axis-col-md-4">
                <div class="axis-form-group _mt-medium">
                  <label class="axis-control-label">
                    {{ textValues?.[field + "_Text"] }}
                  </label>
                  <div>{{ controls[benefitOption.controlIndex].data[0][field] }}</div>
                </div>
              </div>
            }
          }
        }
      }
    }
  </div>
  @if (baseRules["Additional_Death_Benefit_Checkbox"]?.includes("Yes")) {
    <div class="axis-grid _mt-large">
      <div class="_ml-medium _mb-medium">
        <label class="axis-control-label">
          {{ controls[3].label }}
        </label>
      </div>
    </div>
  }
}
